'use client';

import React from 'react';
import { Link, usePathname } from '@/navigation';
import { getUserCity } from '@/shared/lib/city/getUserCity';
import socialIcons from '@/shared/assets/sprites/social.sprite.svg';
import type { IMedcenterType } from '@/entities/medcenter/model/types';
interface MedcenterTypesProps {
  types: IMedcenterType[];
  website: string;
}
export const MedcenterTypes: React.FC<MedcenterTypesProps> = props => {
  const {
    types,
    website
  } = props;
  const displayWebsite = website?.replace(/^https?:\/\//, '').replace(/\/$/, '');
  const pathname = usePathname();
  const city = getUserCity(pathname);
  if (!website && (!types || types.length === 0)) {
    return null;
  }
  return <section className="rounded-2xl bg-bgPrimary p-4" data-sentry-component="MedcenterTypes" data-sentry-source-file="MedcenterTypes.tsx">
      {website && <a className="mb-3 mt-4 flex items-baseline gap-1 font-bold" target="_blank" href={`https://idoctor.kz/away?url=${website}`}>
          <h4 className="mr-1">{displayWebsite}</h4>
          <svg className="size-4 fill-current">
            <use xlinkHref={`${socialIcons}#link`}></use>
          </svg>
        </a>}
      <div>
        {types.map((type, index) => <Link href={{
        pathname: `/${city}/medcenters/type/${type.alias}`
      }} className="mr-1 text-xs text-textSecondary underline" key={`types-${index}`}>
            {type.name + ' '}
          </Link>)}
      </div>
    </section>;
};